import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import {
  GAActions,
  GACategoryName,
  GAEventNames,
  GAUniqueEventIds,
  GenderType,
  PageContentText,
  SubscriptionPlans,
} from "../../helpers/Enums";
import { GET_PARAMS, GET_POPUPS } from "../../const/router";
import usePrepareLink from "../../hooks/usePrepareLink";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useEffect, useState } from "react";
import { recordGaEvent } from "../../helpers/GoogleAnalytics";
import { getMyMemberDetails } from "../../services/memberService";
import { setUserData } from "../../redux/member";
import { getApplicationPageContentText } from "../../services/appSettingService";
import { sendMessageToWebview } from "../../services/native";
import Loader from "react-loader-spinner";
import { PremiumOption, SubscriptionPlan } from "../../typings/premium";
import {
  PlanProductID,
  premiumOptionsDefault,
} from "./utils/premiumOptionsPlan";
import { generatePayPlusPaymentLink } from "../../services/memberService";

const PremiumMessage = (props: any) => {
  let history = useHistory();
  let member = useSelector((state: RootState) => state.member);

  const [premiumOptions, setPremiumOptions] = useState<PremiumOption[]>([]);
  const [premiumSaleTitle, setPremiumSaleTitle] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    recordGaEvent(
      GAEventNames.APP_PURCHASE,
      GACategoryName.PREMIUM_SERVICE,
      "step 1",
      "upgrade me",
      GAUniqueEventIds.VISITED_PREMIUM_PAGE_AD,
    );

    updateMemberDetails();

    // updateMemberDetails().then(() => {
    //   console.log("Member details loaded:", member);
    // });
  }, []);

  // כשה-member משתנה (כולל memberName), זה קורא
  // useEffect(() => {
  //   console.log("Member updated:", member);
  //   if (member.memberName) {
  //     console.log("✅ memberName זמין:", member.memberName);
  //   }
  // }, [member]);

  const documentHelpWithPurchaseEvent = () => {
    recordGaEvent(
      GAEventNames.APP_ENGAGMENT,
      GACategoryName.PREMIUM_SCREEN,
      "סיוע טלפוני",
      "click",
      GAUniqueEventIds.APP_ACTIONS,
    );
  };

  const handleCloseAdvancedSearchModal = () => {
    if (props.isToggle) {
      props.togglePremium();
    } else {
      history.goBack();
    }
  };

  //   const handlePremiumPayment = (planId: number) => {
  //     recordGaEvent(
  //       GAEventNames.APP_PURCHASE,
  //       GACategoryName.PREMIUM_SERVICE,
  //       "step 2",
  //       premiumOptions[planId].planName,
  //       GAUniqueEventIds.CLICKED_ON_UPGRADE_TO_PREMIUM
  //     );

  //     if (window.platform === "ios" || window.platform === "android") {
  //       transferChoosenPlanToNative(planId);
  //     } else {
  //       NiceModal.show("action_modal", {
  //         onNext: () => {
  //           NiceModal.hide("action_modal");
  //         },
  //         headerTitle: "אפשרות תשלום",
  //         contentTitle: (
  //           <div>
  //             <p style={{ margin: "0px" }}>
  //               כרגע אפשר לרכוש מנוי רק באמצעות אפליקציית שושק'ה לטלפון נייד.
  //             </p>{" "}
  //             <p style={{ margin: "0px", marginTop: "5px" }}>
  //               חפשו שושק'ה בחנות האפליקציות
  //             </p>
  //           </div>
  //         ),
  //         primaryButtonText: "הבנתי",
  //         showCloseButton: true,
  //         showSeconderyButton: false,
  //       });
  //     }
  //   };

  const handlePremiumPayment = async (
    option: PremiumOption,
    subPlan: SubscriptionPlan,
  ) => {
    recordGaEvent(
      GAEventNames.APP_PURCHASE,
      GACategoryName.PREMIUM_SERVICE,
      "step 2",
      //   premiumOptions[planId].planName,
      option.planName,
      GAUniqueEventIds.CLICKED_ON_UPGRADE_TO_PREMIUM,
    );

    if (window.platform === "ios" || window.platform === "android") {
      //   transferChoosenPlanToNative(planId);
      transferChoosenPlanToNative(subPlan);
    } else {
      //TODO: For Testing!
      console.log({ option });
      console.log({ subPlan });
      // debugger;
      await handlePayPlusPayment(subPlan);
    }
  };

  const handlePayPlusPayment = async (subPlan: SubscriptionPlan) => {
    try {
      console.log({ member });

      const paymentData = {
        amount: parseFloat(subPlan.price),
        subscriptionPeriod: subPlan.subscriptionPeriod,
        planProductId: subPlan.generalProductId,
      };

      const response = await generatePayPlusPaymentLink(paymentData);

      const paymentLink = response?.data?.data?.payment_page_link;
      if (!paymentLink) {
        throw new Error(
          "Invalid PayPlus response: payment_page_link not found",
        );
      }
      // const paymentLink = response.data.data.payment_page_link; // PayPlus will return the link
      // debugger;

      window.open(paymentLink, "_blank");
      // window.open(paymentLink, "_self");
    } catch (error) {
      console.error("Payment link generation failed:", error);
    }
  };

  // const handlePremiumPayment = (
  //   option: PremiumOption,
  //   subPlan: SubscriptionPlan,
  // ) => {
  //   recordGaEvent(
  //     GAEventNames.APP_PURCHASE,
  //     GACategoryName.PREMIUM_SERVICE,
  //     "step 2",
  //     //   premiumOptions[planId].planName,
  //     option.planName,
  //     GAUniqueEventIds.CLICKED_ON_UPGRADE_TO_PREMIUM,
  //   );

  //   if (window.platform === "ios" || window.platform === "android") {
  //     //   transferChoosenPlanToNative(planId);
  //     transferChoosenPlanToNative(subPlan);
  //   } else {
  //     //TODO: For Testing!
  //     console.log({ option });
  //     console.log({ subPlan });

  //     let premiumUrlLink = "";

  //     switch (subPlan.generalProductId) {
  //       case PlanProductID.ONE_MONTH:
  //         premiumUrlLink = "https://www.motke.co.il/1month";
  //         break;

  //       case PlanProductID.THREE_MONTHS:
  //         premiumUrlLink = "https://www.motke.co.il/3months";
  //         break;

  //       case PlanProductID.SIX_MONTHS:
  //         premiumUrlLink = "https://www.motke.co.il/6months";
  //         break;

  //       case PlanProductID.LIGHT_ONE_MONTH:
  //         premiumUrlLink = "https://www.motke.co.il/light";
  //         break;

  //       default:
  //         premiumUrlLink = "https://www.motke.co.il/premium";
  //         break;
  //     }

  //     window.open(premiumUrlLink, "_blank");

  //     // NiceModal.show("action_modal", {
  //     //   onNext: () => {
  //     //     NiceModal.hide("action_modal");
  //     //   },
  //     //   headerTitle: "אפשרות תשלום",
  //     //   contentTitle: (
  //     //     <div>
  //     //       <p style={{ margin: "0px" }}>
  //     //         כרגע אפשר לרכוש מנוי רק באמצעות אפליקציית שושק'ה לטלפון נייד.
  //     //       </p>{" "}
  //     //       <p style={{ margin: "0px", marginTop: "5px" }}>
  //     //         חפשו שושק'ה בחנות האפליקציות
  //     //       </p>
  //     //     </div>
  //     //   ),
  //     //   primaryButtonText: "הבנתי",
  //     //   showCloseButton: true,
  //     //   showSeconderyButton: false,
  //     // });
  //   }
  // };

  useEffect(() => {
    // if (window.platform !== "ios" && window.platform !== "android") {
    //   getPremiumTitleText();
    // }
    getPremiumTitleText();
    setWhatPlansToShow();
  }, []);

  const premiumPlanDetailslink = usePrepareLink({
    pushToQuery: {
      [GET_PARAMS.popup]: GET_POPUPS.popup.premiumPlanDetails,
    },
    keepOldQuery: true,
  });

  const setWhatPlansToShow = () => {
    // Check if user is on web (not iOS/Android)
    const isWeb = window.platform !== "ios" && window.platform !== "android";

    // Create a copy to avoid mutating the original
    let optionsToShow = JSON.parse(JSON.stringify(premiumOptionsDefault));

    if (isWeb) {
      // Web users: hide light plan and filter to 1-month only
      optionsToShow = optionsToShow.map((option: PremiumOption) => {
        if (option.planId === 1) {
          // Hide light plan for web
          return { ...option, show: false };
        } else if (option.planId === 0) {
          // For premium plan, keep only 1-month subscription
          return {
            ...option,
            subscriptionPlans: option.subscriptionPlans?.filter(
              (plan) => plan.subscriptionPeriod === 1,
            ),
          };
        }
        return option;
      });
    } else {
      // App users: show everything as usual
      if (member.isPremium) {
        if (member.subscriptionPlanId === SubscriptionPlans.LIGHT) {
          optionsToShow[1].show = false;
        }
      }
    }

    setPremiumOptions(optionsToShow);
  };

  // const setWhatPlansToShow = () => {
  //   if (member.isPremium) {
  //     if (member.subscriptionPlanId === SubscriptionPlans.LIGHT) {
  //       //light plan
  //       // premiumOptionsDefault[0].show = false;
  //       premiumOptionsDefault[1].show = false;

  //       setPremiumOptions(premiumOptionsDefault);
  //     } else {
  //       setPremiumOptions(premiumOptionsDefault);
  //     }
  //   } else {
  //     setPremiumOptions(premiumOptionsDefault);
  //   }
  // };

  //handle subscriptions purchase status notification made from native app
  useEffect(() => {
    const notifySubscriptionPurchase = async (isValid: boolean) => {
      if (isValid) {
        await updateMemberDetails();
        NiceModal.show("action_modal", {
          onNext: () => {
            NiceModal.hide("action_modal");
            history.replace(premiumPlanDetailslink);
          },
          headerTitle: "איזה כיף, יש לך מנוי בשושק'ה",
          contentTitle: "אפשרויות חדשות פתוחות בפניך כעת",
          primaryButtonText: "המשך",
          showCloseButton: false,
          showSeconderyButton: false,
        });
      } else {
        NiceModal.show("action_modal", {
          onNext: () => {
            NiceModal.hide("action_modal");
          },
          headerTitle: "שגיאה לא צפויה",
          contentTitle: (
            <div>
              <p>קרתה שגיאה בתהליך ההרשמה למנוי הפרימיום</p>{" "}
              <p>
                לבירור אפשר לפנות ל <span>shoshke@motke.co.il</span>
              </p>
            </div>
          ),
          primaryButtonText: "הבנתי",
          showCloseButton: false,
          showSeconderyButton: false,
        });
      }
    };

    (window as any).notifySubscriptionPurchase = notifySubscriptionPurchase;

    return () => {
      delete (window as any).notifySubscriptionPurchase;
    };
  }, []);

  const updateMemberDetails = async () => {
    try {
      const { data } = await getMyMemberDetails(member.memberCode);
      dispatch(setUserData(data));
    } catch (e) {
      console.log(e);
    }
  };

  const getPremiumTitleText = async () => {
    try {
      const { data } = await getApplicationPageContentText(
        PageContentText.PREMIUM_SALE_TITLE_ID,
      );
      setPremiumSaleTitle(data);
      setIsLoading(false);
    } catch (e) {
      setPremiumSaleTitle("כותרת עמוד");
    }
  };

  //   const transferChoosenPlanToNative = (planId: number) => {
  //     recordGaEvent(
  //       GAEventNames.CLICKED_ON_UPGRADE_TO_PREMIUM,
  //       GACategoryName.PREMIUM,
  //       GAActions.CLICKED_ON_UPGRADE_TO_PREMIUM,
  //       member.nickName,
  //       GAUniqueEventIds.CLICKED_ON_UPGRADE_TO_PREMIUM
  //     );

  //     const plan = premiumOptions[planId];
  //     const token = localStorage.getItem("token");
  //     if (window.platform === "android") {
  //       sendMessageToWebview("start-store-paymnet", {
  //         token: token,
  //         productId: plan?.androidProductId,
  //         member: {
  //           name: member.nickName,
  //           email: member.email,
  //           memberCode: member.memberCode.toString(),
  //         },
  //       });
  //     } else {
  //       sendMessageToWebview("start-store-paymnet", {
  //         token: token,
  //         productId: plan?.appleProductId,
  //         member: {
  //           name: member.nickName,
  //           email: member.email,
  //           memberCode: member.memberCode.toString(),
  //         },
  //       });
  //     }
  //   };

  const transferChoosenPlanToNative = (subPlan: SubscriptionPlan) => {
    recordGaEvent(
      GAEventNames.CLICKED_ON_UPGRADE_TO_PREMIUM,
      GACategoryName.PREMIUM,
      GAActions.CLICKED_ON_UPGRADE_TO_PREMIUM,
      member.nickName,
      GAUniqueEventIds.CLICKED_ON_UPGRADE_TO_PREMIUM,
    );

    // const plan = premiumOptions[planId];

    const token = localStorage.getItem("token");
    if (window.platform === "android") {
      sendMessageToWebview("start-store-paymnet", {
        token: token,
        // productId: plan?.androidProductId,
        productId: subPlan?.androidProductId,

        member: {
          name: member.nickName,
          email: member.email,
          memberCode: member.memberCode.toString(),
        },
      });
    } else {
      sendMessageToWebview("start-store-paymnet", {
        token: token,
        // productId: plan?.appleProductId,
        productId: subPlan?.appleProductId,
        member: {
          name: member.nickName,
          email: member.email,
          memberCode: member.memberCode.toString(),
        },
      });
    }
  };

  const handleBack = () => {
    recordGaEvent(
      GAEventNames.APP_ENGAGMENT,
      GACategoryName.PREMIUM_SCREEN,
      "back button",
      "click",
      GAUniqueEventIds.APP_ACTIONS,
    );

    // NiceModal.hide("premiumMessage_modal");
    // NiceModal.show("bounkair_modal");

    // console.log({ history });
    history.push(history.location.pathname);

    // history.goBack();
  };

  const lightFeatuersList = () => {
    return (
      <>
        <ul role="list" className="prem_option_list w-list-unstyled">
          <li className="prem_option_item">
            <div className="prem_option_block">
              <div className="prem_icon_block option">
                <img src="assets/images/ic_prem_8.svg" loading="lazy" alt="" />
              </div>
              <div className="option_txt_block">
                <h4 className="prior_link_title prem">
                  {member.genderId === GenderType.MALE
                    ? "גלה מי ביקר בפרופיל שלך"
                    : "גלי מי ביקר בפרופיל שלך"}
                </h4>
                <div>כדי לדעת מי כבר הסתקרנו לגביך</div>
              </div>
            </div>
          </li>
          <li className="prem_option_item">
            <div className="prem_option_block">
              <div className="prem_icon_block option">
                <img src="assets/images/ic_prem_9.svg" loading="lazy" alt="" />
              </div>
              <div className="option_txt_block">
                <h4 className="prior_link_title prem">
                  {member.genderId === GenderType.MALE
                    ? "שלח מתנות עם הצעות ההיכרות"
                    : "שלחי מתנות עם הצעות ההיכרות"}
                </h4>
                <div>זאת דרך מעולה להראות עניין מיוחד</div>
              </div>
            </div>
          </li>
        </ul>
      </>
    );
  };

  const premiumFeatuersList = () => {
    return (
      <ul role="list" className="prem_option_list w-list-unstyled">
        <li className="prem_option_item">
          <div className="prem_option_block">
            <div className="prem_icon_block option">
              <img src="assets/images/ic_prem_8.svg" loading="lazy" alt="" />
            </div>
            <div className="option_txt_block">
              <h4 className="prior_link_title prem">
                {member.genderId === GenderType.MALE
                  ? "גלה מי ביקר בפרופיל שלך"
                  : "גלי מי ביקר בפרופיל שלך"}
              </h4>
              <div>כדי לדעת מי כבר הסתקרנו לגביך</div>
            </div>
          </div>
        </li>
        <li className="prem_option_item">
          <div className="prem_option_block">
            <div className="prem_icon_block option">
              <img src="assets/images/ic_prem_9.svg" loading="lazy" alt="" />
            </div>
            <div className="option_txt_block">
              <h4 className="prior_link_title prem">
                {member.genderId === GenderType.MALE
                  ? "שלח מתנות עם הצעות ההיכרות"
                  : "שלחי מתנות עם הצעות ההיכרות"}
              </h4>
              <div>זאת דרך מעולה להראות עניין מיוחד</div>
            </div>
          </div>
        </li>
        <li className="prem_option_item">
          <div className="prem_option_block">
            <div className="prem_icon_block option">
              <img src="assets/images/ic_prem_12.svg" loading="lazy" alt="" />
            </div>
            <div className="option_txt_block">
              <h4 className="prior_link_title prem">
                {member.genderId === GenderType.MALE
                  ? "שלח הצעות היכרות ללא הגבלה"
                  : "שלחי הצעות היכרות ללא הגבלה"}
              </h4>
              <div>בלי מנוי אפשר לשלוח רק חמש הצעות ביום</div>
            </div>
          </div>
        </li>
        <li className="prem_option_item">
          <div className="prem_option_block">
            <div className="prem_icon_block option">
              <img src="assets/images/ic_prem_3.svg" loading="lazy" alt="" />
            </div>
            <div className="option_txt_block">
              <h4 className="prior_link_title prem">
                {member.genderId === GenderType.MALE
                  ? "גלוש באופן סמוי"
                  : "גלשי באופן סמוי"}
              </h4>
              <div>
                {member.genderId === GenderType.MALE
                  ? "לא יראו שאתה מחובר ולא תשאיר עקבות"
                  : "לא יראו שאת מחוברת ולא תשאירי עקבות"}
              </div>
            </div>
          </div>
        </li>
        <li className="prem_option_item">
          <div className="prem_option_block">
            <div className="prem_icon_block option">
              <img src="assets/images/ic_prem_11.svg" loading="lazy" alt="" />
            </div>
            <div className="option_txt_block">
              <h4 className="prior_link_title prem">
                {member.genderId === GenderType.MALE
                  ? "דייק את העדפות החיפוש שלך"
                  : "דייקי את העדפות החיפוש שלך"}
              </h4>
              <div>
                {member.genderId === GenderType.MALE
                  ? "תראה רק את מי שבאמת היית רוצה להכיר"
                  : "תראי רק את מי שבאמת היית רוצה להכיר"}
              </div>
            </div>
          </div>
        </li>
        <li className="prem_option_item">
          <div className="prem_option_block">
            <div className="prem_icon_block option">
              <img src="assets/images/ic_prem_10.svg" loading="lazy" alt="" />
            </div>
            <div className="option_txt_block">
              <h4 className="prior_link_title prem">
                {member.genderId === GenderType.MALE
                  ? "הפעל חיפושים וסינונים מתקדמים בפיד"
                  : "הפעילי חיפושים וסינונים מתקדמים בפיד"}
                {/* סינונים וחיפושים מתקדמים בפיד */}
              </h4>
              {/* <div>למשל צפייה בפרופילים מאומתים בלבד או במצטרפים חדשים</div> */}
              <div>
                <div>
                  {member.genderId === GenderType.MALE
                    ? "חפש חברים לפי שם ועיר מגורים"
                    : "חפשי חברים לפי שם ועיר מגורים"}
                </div>
                <div>
                  {member.genderId === GenderType.MALE
                    ? "סנן פרופילים מאומתים או חדשים"
                    : "סנני פרופילים מאומתים או חדשים"}
                </div>
              </div>
            </div>
          </div>
        </li>
        <li className="prem_option_item">
          <div className="prem_option_block motke">
            <div className="prem_icon_block option">
              <img src="assets/images/ic_prem_13.svg" loading="lazy" alt="" />
            </div>
            <div className="option_txt_block">
              <h4 className="prior_link_title prem">
                10% הנחה על השתתפות בפעילויות
              </h4>
            </div>
          </div>
        </li>
      </ul>
    );
  };

  const premiumOptionsComponent = () => {
    // console.log("begin premiumOptionsComponent");
    return (
      <>
        <a
          onClick={handleBack}
          href="#"
          className="meet_close prem w-inline-block"
        >
          <img src="assets/images/ic_back_white.svg" loading="lazy" alt="" />
        </a>
        <div className="content_sec prem_options">
          <div className="content_block premium_opt">
            <div className="prem_options_group" style={{ minHeight: "680px" }}>
              {member.subscriptionPlanId === SubscriptionPlans.LIGHT &&
                member.isPremium && (
                  <h1 className="center_title options">
                    {GenderType.MALE === member.genderId
                      ? "שדרג לפרימיום"
                      : "שדרגי לפרימיום"}
                  </h1>
                )}
              {member.subscriptionPlanId === SubscriptionPlans.LIGHT &&
                member.isPremium && (
                  <div className="center_txt">
                    יש לך כרגע מנוי שושק'ה לייט, אפשר לשדרג למנוי פרימיום כדי
                    לפתוח את כל האפשרויות
                  </div>
                )}
              {/* <h1 className="center_title">חבילות פרימיום</h1>
                            <h3 className="prem_opt_title">בחר/י את התוכנית המתאימה לך:</h3>
                            <div className="prem_banner_block">
                                <img
                                    src="assets/images/prem_banner_pict.svg"
                                    loading="lazy"
                                    alt=""
                                    className="prem_banner_pict mirror"
                                />
                                <img
                                    src="assets/images/prem_banner_pict.svg"
                                    loading="lazy"
                                    alt=""
                                    className="prem_banner_pict"
                                />
                                <div>מבצע לזמן מוגבל, שבוע ראשון חינם לנרשמים חדשים!</div>
                            </div> */}
              <ul role="list" className="premium_opt_list w-list-unstyled">
                {premiumOptions.map((option, index) => {
                  if (option.show) {
                    return (
                      <div className="prem_option_group">
                        <div
                          className={
                            option.isLight
                              ? "prem_logo_block light"
                              : "prem_logo_block"
                          }
                        >
                          <img src={option.image} loading="lazy" alt="" />
                        </div>
                        {!option.isLight &&
                          (window.platform === "ios" ||
                            window.platform === "android") && (
                            <div className="prem_price_gr">
                              <div className="prem_price_txt">
                                {premiumSaleTitle}
                              </div>
                            </div>
                          )}
                        <div className="prem_price_gr">
                          {/* <div className="prem_price_txt num">{option.price}</div>
                                                    <div className="prem_price_txt">שקלים בחודש</div> */}
                        </div>
                        {option.isLight
                          ? lightFeatuersList()
                          : premiumFeatuersList()}
                        {/* <a
                          href="#"
                          className="button_full prem_order w-inline-block"
                          onClick={() => handlePremiumPayment(option.planId)}
                        >
                          <div className="prem_button_txt">
                            {option.price + " " + option.currencyDescription}
                          </div>
                          <div>מתחדש מידי חודש</div>
                        </a> */}

                        {/* <a
                          href="#"
                          className="prem_opt_link w-inline-block"
                          onClick={() => handlePremiumPayment(option.planId)}
                        >
                          <div className="prem_title_gr">
                            <div className="premium_title_num">
                              {option.subscriptionPeriod}
                            </div>
                            <div>
                              {option.subscriptionPeriod === 1
                                ? "חודש"
                                : "חודשים"}
                            </div>
                          </div>
                          <div className="prem_opt_line"></div>
                          <div className="prem_opt_info">
                            <div className="prem_opt_txt">
                              {option.price + " " + option.currencyDescription}
                            </div>
                            <div>מתחדש מידי חודש</div>
                          </div>
                        </a> */}

                        {option.subscriptionPlans?.map((subPlan, index) => {
                          return (
                            <div className="prem_opt_item">
                              <a
                                href="#"
                                className="prem_opt_link w-inline-block"
                                //TODO: Make it compatible to the subPlan index!!!!!!!
                                onClick={() =>
                                  //   handlePremiumPayment(option.planId)
                                  handlePremiumPayment(option, subPlan)
                                }
                              >
                                <div className="prem_title_gr">
                                  <div className="premium_title_num">
                                    {subPlan.subscriptionPeriod}
                                  </div>
                                  <div>
                                    {subPlan.subscriptionPeriod > 1
                                      ? "חודשים"
                                      : "חודש"}
                                  </div>
                                </div>
                                <div className="prem_opt_line"></div>
                                <div className="prem_opt_info">
                                  <div className="prem_opt_txt">
                                    {option.currencyDescription +
                                      subPlan.price +
                                      " " +
                                      option.periodDescription}
                                  </div>
                                  <div>
                                    {subPlan.subscriptionPeriod > 1 ? (
                                      // <div style={{ width: "292px" }}>
                                      <div>{subPlan.planDescription}</div>
                                    ) : (
                                      "מתחדש מידי חודש"
                                    )}
                                  </div>
                                </div>
                              </a>
                            </div>
                          );
                        })}

                        {/* {option.subscriptionPlans?.map((subPlan, index) => {
                          return (
                            <div className="prem_opt_item">
                              <a
                                href="#"
                                className="prem_opt_link w-inline-block"
                                //TODO: Make it compatible to the subPlan index!!!!!!!
                                onClick={() =>
                                  //   handlePremiumPayment(option.planId)
                                  handlePremiumPayment(option, subPlan)
                                }
                              >
                                <div className="prem_title_gr">
                                  <div className="premium_title_num">
                                    {subPlan.subscriptionPeriod}
                                  </div>
                                  <div>
                                    {subPlan.subscriptionPeriod > 1
                                      ? "חודשים"
                                      : "חודש"}
                                  </div>
                                </div>
                                <div className="prem_opt_line"></div>
                                <div className="prem_opt_info">
                                  <div className="prem_opt_txt">
                                    {option.currencyDescription +
                                      subPlan.price +
                                      " " +
                                      option.periodDescription}
                                  </div>
                                  <div>
                                    {subPlan.subscriptionPeriod > 1 ? (
                                      // <div style={{ width: "292px" }}>
                                      <div>{subPlan.planDescription}</div>
                                    ) : (
                                      "מתחדש מידי חודש"
                                    )}
                                  </div>
                                </div>
                              </a>
                            </div>
                          );
                        })} */}

                        {/* <a
                          href="#"
                          className="prem_opt_link w-inline-block"
                          onClick={() => handlePremiumPayment(option.planId)}
                        >
                          <div className="prem_title_gr">
                            <div className="premium_title_num">
                              {option.subscriptionPeriod}
                            </div>
                            <div>
                              {option.subscriptionPeriod === 1
                                ? "חודש"
                                : "חודשים"}
                            </div>
                          </div>
                          <div className="prem_opt_line"></div>
                          <div className="prem_opt_info">
                            <div className="prem_opt_txt">
                              {option.price + " " + option.currencyDescription}
                            </div>
                            <div>מתחדש מידי חודש</div>
                          </div>
                        </a> */}
                      </div>
                    );
                  }
                })}
              </ul>
              <a
                onClick={documentHelpWithPurchaseEvent}
                href="https://api.whatsapp.com/send/?phone=972533769023&text&type=phone_number&app_absent=0"
                target="_blank"
                className="skip_link block"
              >
                זקוקים לסיוע? כתבו לנו בווטסאפ
              </a>
              {/* <a
                onClick={documentHelpWithPurchaseEvent}
                href="https://docs.google.com/forms/d/e/1FAIpQLSeyRWjsIw0lW8xtLW6mRGuLeB2pK1LDSEAUTw7bOL7Of6gv2Q/viewform"
                target="_blank"
                className="skip_link block"
              >
                לסיוע טלפוני ברכישה אפשר ללחוץ כאן
              </a> */}
            </div>
          </div>
        </div>

        {/* <div className="nav_sec full">
                    <div className="content_block footer">
                        <a href="#" onClick={transferChoosenPlanToNative} className="button_full premium_options w-button">
                            {member.genderId === GenderType.MALE ? "בחר" : "בחרי"}
                        </a>
                        <div className="button_info_txt">
                            רכישת המנוי נעשית דרך חנות האפליקציות. המנוי מתחדש אוטומטית באותם התנאים
                            בהתאם לתוכנית שנבחרה. אפשר לבטל את המנוי בכל שלב דרך החנות.
                        </div>
                    </div>
                </div> */}
      </>
    );
  };

  const premiumAd = () => {
    return (
      <>
        <a
          href="#"
          className="meet_close prem_options w-inline-block"
          onClick={handleCloseAdvancedSearchModal}
        >
          <img src="/assets/images/ic_back_white.svg" loading="lazy" alt="" />
        </a>
        <section className="content_sec full" />
        <div className="content_sec prem_options">
          <div className="content_block premium_opt">
            <div className="prem_options_group">
              <h1 className="center_title options">
                {member.genderId === GenderType.MALE
                  ? "שדרג לפרימיום"
                  : "שדרגי לפרימיום"}
              </h1>
              <div className="center_txt">
                {member.genderId === GenderType.MALE ? "נסה" : "נסי"} את שושק'ה
                פרימיום בחינם{" "}
              </div>

              {member.isPremium === false && (
                <div className="prem_option_group">
                  <div className="prem_logo_block light">
                    <img
                      src="assets/images/logo_sh_light.svg"
                      loading="lazy"
                      alt=""
                    />
                  </div>
                  <div className="prem_price_gr">
                    <div className="prem_price_txt num">35</div>
                    <div className="prem_price_txt">שקלים בחודש</div>
                  </div>
                  <ul role="list" className="prem_option_list w-list-unstyled">
                    <li className="prem_option_item">
                      <div className="prem_option_block">
                        <div className="prem_icon_block option">
                          <img
                            src="assets/images/ic_prem_8.svg"
                            loading="lazy"
                            alt=""
                          />
                        </div>
                        <div className="option_txt_block">
                          <h4 className="prior_link_title prem">
                            {member.genderId === GenderType.MALE
                              ? "גלה מי ביקר בפרופיל שלך"
                              : "גלי מי ביקר בפרופיל שלך"}
                          </h4>
                          <div>כדי לדעת מי כבר הסתקרנו לגביך</div>
                        </div>
                      </div>
                    </li>
                    <li className="prem_option_item">
                      <div className="prem_option_block">
                        <div className="prem_icon_block option">
                          <img
                            src="assets/images/ic_prem_9.svg"
                            loading="lazy"
                            alt=""
                          />
                        </div>
                        <div className="option_txt_block">
                          <h4 className="prior_link_title prem">
                            {member.genderId === GenderType.MALE
                              ? "שלח מתנות עם הצעות ההיכרות"
                              : "שלחי מתנות עם הצעות ההיכרות"}
                          </h4>
                          <div>זאת דרך מעולה להראות עניין מיוחד</div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              )}

              <div className="prem_option_group premium">
                <div className="prem_logo_block">
                  <img
                    src="assets/images/logo_sh_premium.svg"
                    loading="lazy"
                    alt=""
                  />
                </div>
                <div className="prem_price_gr">
                  {/* <div className="prem_price_txt">החל מ-</div> */}
                  <div className="prem_price_txt num">98</div>
                  <div className="prem_price_txt">שקלים בחודש</div>
                </div>
                <ul role="list" className="prem_option_list w-list-unstyled">
                  <li className="prem_option_item">
                    <div className="prem_option_block">
                      <div className="prem_icon_block option">
                        <img
                          src="assets/images/ic_prem_8.svg"
                          loading="lazy"
                          alt=""
                        />
                      </div>
                      <div className="option_txt_block">
                        <h4 className="prior_link_title prem">
                          {member.genderId === GenderType.MALE
                            ? "גלה מי ביקר בפרופיל שלך"
                            : "גלי מי ביקר בפרופיל שלך"}
                        </h4>
                        <div>כדי לדעת מי כבר הסתקרנו לגביך</div>
                      </div>
                    </div>
                  </li>
                  <li className="prem_option_item">
                    <div className="prem_option_block">
                      <div className="prem_icon_block option">
                        <img
                          src="assets/images/ic_prem_9.svg"
                          loading="lazy"
                          alt=""
                        />
                      </div>
                      <div className="option_txt_block">
                        <h4 className="prior_link_title prem">
                          {member.genderId === GenderType.MALE
                            ? "שלח מתנות עם הצעות ההיכרות"
                            : "שלחי מתנות עם הצעות ההיכרות"}
                        </h4>
                        <div>זאת דרך מעולה להראות עניין מיוחד</div>
                      </div>
                    </div>
                  </li>
                  <li className="prem_option_item">
                    <div className="prem_option_block">
                      <div className="prem_icon_block option">
                        <img
                          src="assets/images/ic_prem_12.svg"
                          loading="lazy"
                          alt=""
                        />
                      </div>
                      <div className="option_txt_block">
                        <h4 className="prior_link_title prem">
                          {member.genderId === GenderType.MALE
                            ? "שלח הצעות היכרות ללא הגבלה"
                            : "שלחי הצעות היכרות ללא הגבלה"}
                        </h4>
                        <div>בלי מנוי אפשר לשלוח רק חמש הצעות ביום</div>
                      </div>
                    </div>
                  </li>
                  <li className="prem_option_item">
                    <div className="prem_option_block">
                      <div className="prem_icon_block option">
                        <img
                          src="assets/images/ic_prem_3.svg"
                          loading="lazy"
                          alt=""
                        />
                      </div>
                      <div className="option_txt_block">
                        <h4 className="prior_link_title prem">
                          {member.genderId === GenderType.MALE
                            ? "גלוש באופן סמוי"
                            : "גלשי באופן סמוי"}
                        </h4>
                        <div>
                          {member.genderId === GenderType.MALE
                            ? "לא יראו שאתה מחובר ולא תשאיר עקבות"
                            : "לא יראו שאת מחוברת ולא תשאירי עקבות"}
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="prem_option_item">
                    <div className="prem_option_block">
                      <div className="prem_icon_block option">
                        <img
                          src="assets/images/ic_prem_11.svg"
                          loading="lazy"
                          alt=""
                        />
                      </div>
                      <div className="option_txt_block">
                        <h4 className="prior_link_title prem">
                          {member.genderId === GenderType.MALE
                            ? "דייק את העדפות החיפוש שלך"
                            : "דייקי את העדפות החיפוש שלך"}
                        </h4>
                        <div>
                          {member.genderId === GenderType.MALE
                            ? "תראה רק את מי שבאמת היית רוצה להכיר"
                            : "תראי רק את מי שבאמת היית רוצה להכיר"}
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="prem_option_item">
                    <div className="prem_option_block">
                      <div className="prem_icon_block option">
                        <img
                          src="assets/images/ic_prem_10.svg"
                          loading="lazy"
                          alt=""
                        />
                      </div>
                      <div className="option_txt_block">
                        <h4 className="prior_link_title prem">
                          {member.genderId === GenderType.MALE
                            ? "הפעל סינונים מתקדמים בפיד"
                            : "הפעילי סינונים מתקדמים בפיד"}
                        </h4>
                        <div>
                          למשל צפייה בפרופילים מאומתים בלבד או במצטרפים חדשים
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <a
                onClick={documentHelpWithPurchaseEvent}
                href="https://api.whatsapp.com/send/?phone=972533769023&text&type=phone_number&app_absent=0"
                target="_blank"
                className="skip_link options"
              >
                זקוקים לסיוע? כתבו לנו בווטסאפ
              </a>
              {/* <a
                onClick={documentHelpWithPurchaseEvent}
                href="https://docs.google.com/forms/d/e/1FAIpQLSeyRWjsIw0lW8xtLW6mRGuLeB2pK1LDSEAUTw7bOL7Of6gv2Q/viewform"
                target="_blank"
                className="skip_link options"
              >
                לסיוע טלפוני ברכישה אפשר ללחוץ כאן
              </a> */}
            </div>
          </div>
        </div>
        <div className="nav_sec full">
          <div className="content_block footer">
            {/* <a href="#" className="button_full premium_opt w-button" onClick={handlePremiumPayment}>
                            שדרגו אותי
                        </a> */}
          </div>
        </div>
      </>
    );
  };

  //TODO: For Debugging!
  useEffect(() => {
    console.log("PremiumMessage Member: ", member);
  }, [member]);

  return (
    <>
      {isLoading ? (
        <div
          style={{
            height: "100%",
            margin: "auto",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Loader type="ThreeDots" color="#f47373" />
        </div>
      ) : (
        premiumOptionsComponent()
      )}
    </>
  );
};

export default PremiumMessage;
